import { Injectable } from '@angular/core';
import { HttpService } from '@app/core/services/http/http.service';
import { URLParamsService } from '@shared/services/url-params.service';
import { DeliveryViewModel } from '@shared/models/delivery-view.model';
import { DeliveryNewViewModel } from '@shared/models/delivery-new-view.model';
import { Paginator } from '@app/shared/models/paginator';
import { FirebaseService } from '@app/shared/services/firebase.service';
import { ModelList } from '../models/ModelList';
import { Observable } from 'rxjs';

@Injectable()
export class DeliveryService {
  static readonly url = 'DeliveryUser/';
  private cached: DeliveryViewModel[] = [];

  constructor(private httpService: HttpService, private firebaseService: FirebaseService) { }

  get(branchId: number, filters: Paginator): Observable<ModelList<DeliveryViewModel>> {
    const url = URLParamsService.buildUrl(`${DeliveryService.url}GetDeliveryUsers`, {
      BranchID: branchId,
      pageSize: filters.pageSize,
      page: filters.pageIndex + 1
    });

    return this.httpService.GetRequest<ModelList<DeliveryViewModel>>(url);
  }

  getById(id: number): Promise<DeliveryViewModel> {
    const url = URLParamsService.buildUrl(`${DeliveryService.url}GetDeliveryUser`, {
      id: id
    });

    return new Promise((resolve, reject) => {

      if (this.cached && this.cached.find(d => d.id === id)) {
        return resolve(this.cached.find(d => d.id === id));
      }

      this.httpService.GetRequest<DeliveryViewModel>(url).subscribe((data) => {
        this.cached.push(data);
        this.firebaseService.deleteDelivery(String(id)).then(() => {
          resolve(data);
        }).catch((error) => reject(error));
      }, (error) => reject(error));
    });
  }

  save(delivery: DeliveryNewViewModel): Observable<DeliveryViewModel> {
    const url = delivery.ID ? `${DeliveryService.url}EditDeliveryUser` : `${DeliveryService.url}SaveDeliveryUser`;
    const input = new FormData();
    if (delivery.ID) {
      input.append('ID', String(delivery.ID));
    }
    input.append('Name', delivery.Name);
    input.append('Username', delivery.Username);
    input.append('BranchID', String(delivery.BranchID));
    input.append('File', delivery.File);
    input.append('Active', String(delivery.Active));
    input.append('CanDeliverOrders', String(delivery.CanDeliverOrders));
    input.append('Phone', delivery.Phone);
    input.append('UserHQ', delivery.UserHQ);
    input.append('Password', delivery.Password);
    return this.httpService.PostRequestFormData<DeliveryViewModel, FormData>(url, input);
  }

  delete(id: number): Promise<any> {
    const url = `${DeliveryService.url}DeleteDeliveryUser/${id}`;

    return new Promise((resolve, reject) => {
      this.httpService.DeleteRequest<DeliveryViewModel, null>(url, null).subscribe((data) => {
        this.firebaseService.deleteDelivery(String(id)).then(() => {
          resolve(data);
        }).catch((error) => reject(error));
      }, (error) => reject(error));
    });
  }
}
